import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_course_config",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "course_config",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_course_config_button",
  "data-kt-drawer-close": "#kt_drawer_course_config_close",
  "data-kt-drawer-width": "75.5vw"
}
const _hoisted_2 = {
  id: "kt_course_config",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_course_config_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Edit Course Configuration </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_course_config_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_course_config_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_course_config_body",
  "data-kt-scroll-dependencies": "#kt_course_config_header, #kt_course_config_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "card-body p-2" }
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_course_config_scroll"
}
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "card mb-5 mb-xl-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#create_entity",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Course Configuration ")
  ])
], -1)
const _hoisted_11 = {
  id: "create_entity",
  class: "collapse show"
}
const _hoisted_12 = { class: "collapse show" }
const _hoisted_13 = { class: "card-body border-top p-5" }
const _hoisted_14 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Enrollment Grace (day)")
], -1)
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Replacement %")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " % of dropout replacement by new trainee ", -1)
const _hoisted_21 = { class: "row mt-3" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Employemnt Bill Claim %")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " % of employment required for claim. ", -1)
const _hoisted_25 = { class: "col-md-3 mt-3 p-5" }
const _hoisted_26 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Assessment Applicable? ", -1)
const _hoisted_28 = { class: "col-md-3 mt-3 p-5" }
const _hoisted_29 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Certification Applicable? ", -1)
const _hoisted_31 = {
  class: "py-5 text-center",
  id: "kt_course_config_footer"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_course_config_cancel",
  class: "btn btn-secondary me-5"
}, " Discard ", -1)
const _hoisted_33 = ["data-kt-indicator"]
const _hoisted_34 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_35 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_36 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _hoisted_17,
                                  _createVNode(_component_Field, {
                                    type: "number",
                                    modelValue: _ctx.formData.e_grace,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.e_grace) = $event)),
                                    name: "e_grace",
                                    class: "form-control"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "e_grace",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _hoisted_19,
                                  _createVNode(_component_Field, {
                                    type: "number",
                                    modelValue: _ctx.formData.dropout_rep_perc_per_batch,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.dropout_rep_perc_per_batch) = $event)),
                                    name: "dropout_rep_perc_per_batch\t",
                                    class: "form-control"
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_20,
                                  _createVNode(_component_ErrorMessage, {
                                    name: "dropout_rep_perc_per_batch\t",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _hoisted_23,
                                  _createVNode(_component_Field, {
                                    type: "number",
                                    modelValue: _ctx.formData.emp_bill_claim_perc,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.emp_bill_claim_perc) = $event)),
                                    name: "emp_bill_claim_perc",
                                    class: "form-control"
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_24
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("label", _hoisted_26, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.assesmentchecked) = $event)),
                                      "true-value": "yes",
                                      "false-value": "no",
                                      type: "checkbox",
                                      class: "form-check-input",
                                      name: "assessment_applicable",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isAssesmentCheck($event)))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.assesmentchecked]
                                    ]),
                                    _hoisted_27
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("label", _hoisted_29, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.certificationchecked) = $event)),
                                      "true-value": "yes",
                                      "false-value": "no",
                                      type: "checkbox",
                                      class: "form-check-input",
                                      name: "certification_applicable",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isCertificationCheck($event)))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.certificationchecked]
                                    ]),
                                    _hoisted_30
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_35, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_37
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_33)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}